import styled from "styled-components";

export const ContainerForm = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 16px;
  padding: 20px;
  width: 320px;
  height: auto;
  gap: 16px;
  border: 1px solid var(--Background-Colors-Secondary-background-color, #dde2e8);

  @media only screen and (min-width: 769px) {
    width: auto;
    padding: 24px;
    gap: 24px;
  }
`;

export const TextHead = styled.p`
  color: #1f2d3d;
  margin: 0;
  font-size: 20px;
  line-height: 29px;
  font-weight: bold;

  @media only screen and (min-width: 769px) {
    font-size: 24px;
    line-height: 35px;
  }
`;

export const TextRegular = styled.p`
  text-decoration: none;
  margin: 0;
  font-size: ${(props) => props?.fontSize ?? "13px"};
  line-height: 16px;
  color: #1f2d3d;

  @media only screen and (min-width: 769px) {
    font-size: ${(props) => props?.fontSize ?? "13px"};
    line-height: 16px;
  }
`;

export const Button = styled.button`
  display: flex;
  width: 100%;
  height: 44px;
  padding: 12px 16px;
  justify-content: center;
  align-items: center;
  align-self: center;
  color: white;
  font-size: 16px;
  font-weight: bold;
  border: none;
  border-radius: 40px;
  background-color: #00bcf1;
  @media only screen and (min-width: 768px) {
    max-width: 327px;
  }
`;

export const ContainerText = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  border-radius: 4px;
`;

export const Input = styled.input`
  border: none;
  margin-left: 8px;
  height: 24px;
  max-width: 200px;
  font-size: 13px;

  @media only screen and (min-width: 768px) {
    max-width: 240px;
  }
`;
